import { parse } from 'qs';

import { APP_LINK } from '../constants';

export const getQRCodeLink = () => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const sharingCode = parse(search, { ignoreQueryPrefix: true }).code || '';

  if (sharingCode) {
    return (
      APP_LINK +
      encodeURIComponent(
        `&af_dp=solartrip://&deep_link_value=solartrip://solartrip.com/guestOrders/${sharingCode}`
      )
    );
  }

  return APP_LINK;
};
